export const actionTypes = {
  SET_PROJECT_LIST: "SET_PROJECT_LIST",
  SET_PRODUCT_LIST: "SET_PRODUCT_LIST",
  SET_PRODUCT_SELECT_LIST: "SET_PRODUCT_SELECT_LIST",
  SET_INDUSTRY_TYPE_LIST: "SET_INDUSTRY_TYPE_LIST",
  SET_MESSAGE: "SET_MESSAGE",
  SET_FORECAST_CATEGORY: "SET_FORECAST_CATEGORY",
  SET_PROJECT_STATUS: "SET_PROJECT_STATUS",
  SET_CONSTANT_LIST: "SET_CONSTANT_LIST",
  SET_PROJECT_LOG: "SET_PROJECT_LOG",
  SET_PROJECT_CHANGE_PAGE_LIST: "SET_PROJECT_CHANGE_PAGE_LIST",
  SET_COUNTRY_LIST: "SET_COUNTRY_LIST",
};